import React, { useState } from "react";
import { Icon, Dropdown, Loader } from "rsuite";
import styled from "styled-components";

import { servicePick, downloadDataAsFile, onDownloadPdf } from "utils";
import { getCsvResponse } from "api/loginRoutes";
import {
    INCORPORATED_GROUP_LIST_API,
    SMS_SUPPLIER_GAN_GROUP_GET_LIST_METHOD,
    RATECARD_LIST_INCORPORATED_DEFAULT_DIALER,
    SMS_RATECARD_LIST_INCORPORATED_DEFAULT_DIALER

} from "const/apiMethods";

export default ({ filter, service, ganSpKey, account, getTemplate }) => {
    const [loading, setLoading] = useState(false);

    const method = servicePick(service, INCORPORATED_GROUP_LIST_API, SMS_SUPPLIER_GAN_GROUP_GET_LIST_METHOD);

    const downloadIncorporatedGroup = () => {
        setLoading(true);
        getCsvResponse(method)
            .then((response) => {
                const file = "gan_group.csv";
                downloadDataAsFile(response, file);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const methodPDF = servicePick(service, RATECARD_LIST_INCORPORATED_DEFAULT_DIALER, SMS_RATECARD_LIST_INCORPORATED_DEFAULT_DIALER)

    const paramsPDF = {
        filter: {
            str: filter?.str || "",
            sp_key: ganSpKey?.sp_key,
            cur_key: servicePick(service, 1, 2)
        }
    };

    return (
        <StyledDropdown
            title={<>
                <Icon icon="upload2" />Download
            </>}
            appearance="default"
            disabled={loading}
            loading={loading}
            placement="bottomEnd"
        >
            <Dropdown.Item
                onClick={downloadIncorporatedGroup}
            >
                Export GAN Group (CSV)
            </Dropdown.Item>

            <Dropdown.Item
                onClick={() => {
                    setLoading(true);
                    onDownloadPdf(
                        account,
                        paramsPDF,
                        methodPDF,
                        getTemplate,
                        () => {
                            setLoading(false);
                        }
                    );
                }}
            >
                Export price list with ranges (PDF)
            </Dropdown.Item>
        </StyledDropdown>
    );
};

const StyledDropdown = styled(Dropdown)`
    && {
        margin-right: 10px;
    }
`;

const StyledLoader = styled(Loader)`
    & span.rs-loader-spin {
        margin-top: 3px;
        margin-right: 5px;
    }
`;